<template>
  <div>
    	<div id="wrapper">
        <img src="../assets/my/2025.png" style="height:120px;"/>
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Paper Submission
    				</strong>
    			</p>
    			<p style="font-size:large; float:none;">
                   Please submit a full-length paper (8 page IEEE 2-column format) through the online submission system. Electronic submissions in pdf format are required.
    			</p>
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Online Submission
    				</strong>
    			</p>
    			<p style="font-size:large; float:none;">Click<a href="https://wi-lab.com/cyberchair/2025/bibm25/index.php"> here </a> ("The 16th Integrative Data Analysis in Systems Biology Workshop") to submit your paper to IDASB2025
                </p>
                <!--
                <p>Then select <a href="https://wi-lab.com/cyberchair/2013/bibm13/scripts/submit.php?subarea=SA&undisplay_deta> 10.	Integrative Data Analysis in Systems Biology </a>
                </p>
                -->
                <br/>

    		  <p style="font-size:large; float:none;">
    				<strong>
    				    Key Dates
    				</strong>
    			</p>
<table width="100%" border="0" cellspacing="4" cellpadding="0">
                    <!-- <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="40%"><span class="my-c">Due date for full workshop papers submission:</span></td>
                        <td width="60%"><span class="my-c">October 10, 2023</span></td>
                    </tr> -->
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Due&nbsp;date&nbsp;for&nbsp;full&nbsp;workshop&nbsp;papers&nbsp;submission:</span>
                    </tr>
                    <tr>
                      <span class="my-c">October&nbsp;15,&nbsp;2025</span>
                    </tr>
                    <!-- <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="35%"><span class="my-c">Notification of paper acceptance to authors:</span></td>
                        <td width="60%"><span class="my-c">November 5,2023</span></td>
                    </tr> -->
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Notification&nbsp;of&nbsp;paper&nbsp;acceptance&nbsp;to&nbsp;authors:</span>
                    </tr>
                    <tr>
                      <span class="my-c">November&nbsp;15,2025</span>
                    </tr>




                    <!-- <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="45%"><span class="my-c">Camera-ready of accepted papers:</span></td>
                        <td width="60%"><span class="my-c">November 21,2023</span></td>
                    </tr> -->
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Camera-ready&nbsp;of&nbsp;accepted&nbsp;papers:</span>
                    </tr>
                    <tr>
                      <span class="my-c">November&nbsp;23,2025</span>
                    </tr>
                    <!-- <tr>
                        <td width="5%">&nbsp;</td>
                        <td width="35%"><span class="my-c">Workshop dates:</span></td>
                        <td width="60%"><span class="my-c">December 5-8,2023</span></td>
                    </tr> -->
                    <tr>
                        <td>&nbsp;</td>
                      </tr>
                    <tr>
                      <span class="my-c">Workshop&nbsp;date:</span>
                    </tr>
                    <tr>
                      <span class="my-c">December&nbsp;<span style="text-decoration: line-through; color: red;">16</span><span >15</span>,2025</span>
                    </tr>
                </table>


              <footer-component></footer-component>
    		</div>

    	</div>

  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
  .crossed-number {
    position: relative;
  }

  .crossed-number::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background-color: red; /* 划线颜色 */
    transform: translateY(-50%);
    z-index: 1;
  }
</style>
